import React from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import { validated } from "react-custom-validation";
import clone from 'clone';

import { isRequired, isRequiredIfTrue } from 'utils/validations';

import Button from 'components/Button';
import Form from 'components/Form';
import FormColumn from 'components/FormColumn';
import FormRow from 'components/FormRow';
import FormValidationMessage from 'components/FormValidationMessage';
import Label from 'components/Label';
import LoadingCircle from 'components/LoadingCircle';
import Modal from 'components/Modal';
import Textbox from 'components/Textbox';

const REGIONS = [
    'Midwest',
    'Northeast',
    'Northwest',
    'Southeast',
    'Southwest'
];

class AdEditModal extends React.Component {
    static propTypes = {
        ad: PropTypes.object.isRequired,
        closeEditModal: PropTypes.func.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        isSaving: PropTypes.bool,
        setAd: PropTypes.func.isRequired,
        setUseViewUrl: PropTypes.func.isRequired,
        show: PropTypes.bool,
        useViewUrl: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {
            defaultData: clone(props.ad)
        };
    }

    _handleCancel = () => {
        this.props.setAd({});
        this.props.closeEditModal();
    };

    _handleChange(event) {
        console.log(event.target.name);
        let { name, value } = event.target;
        let newAdObj = update(this.props.ad, {});
        if(name === 'regions') {
            if(!newAdObj.regions) {
                value = [value];
            } else {
                let newRegionArray = clone(newAdObj.regions);
                let foundIndex = newRegionArray.findIndex((r) => r === value);
                if(foundIndex === -1) {
                    newRegionArray.push(value);
                } else {
                    newRegionArray.splice(foundIndex, 1);
                }
                value = newRegionArray;
            }
        } else if(/thumbnailHeight|thumbnailWidth/.test(name) && value) {
            value = parseFloat(value);
        }
        newAdObj[name] = value;
        this.props.setAd(newAdObj);
    }

    _handleCheckboxChange(event) {
        this.props.setUseViewUrl(event.target.checked);
    }

    handleSubmit = (isValid) => {
        if(isValid) {
            this.props.handleSubmit()
                .then(() => {
                    setTimeout(() => {
                        this.props.setAd({});
                        this.props.$fieldEvent('reset')
                    }, 1000);
                })
        }

    };

    render() {
        let { ad, isSaving, $field, $submit, $validation } = this.props;
        return (
            <Modal className="ad-edit-modal"
                   contentLabel="Edit a campaign modal"
                   show={this.props.show === true}
                   title="Edit Campaign">
                <Form>
                    <FormRow>
                        <Textbox
                            id="txtName"
                            label="Name"
                            name="name"
                            required
                            type="text"
                            validation={$validation.name}
                            value={ad.name || ''}
                            {...$field('name', (event) => this._handleChange(event))}
                        />
                    </FormRow>

                    {/*<FormRow className="ad-edit-modal__checkbox-wrapper">
                        <input type="checkbox" checked={this.props.useViewUrl} onChange={(event) => this._handleCheckboxChange(event)} id="chkUseViewUrl" />
                        <Label htmlFor="chkUseViewUrl">Use HTML for Ad</Label>
                    </FormRow>*/}

                    {/*{this.props.useViewUrl ? (*/}
                        <FormRow>
                            <Textbox
                                id="txtViewUrl"
                                label="URL of Ad"
                                name="viewUrl"
                                required
                                type="text"
                                value={ad.viewUrl || ''}
                                {...$field('viewUrl', (event) => this._handleChange(event))}
                            />
                        </FormRow>
                    {/*) : (*/}
                        <div>
                            <FormRow>
                                <Textbox
                                    id="txtTitle"
                                    label="Title"
                                    name="titleCopy"
                                    required
                                    type="text"
                                    validation={$validation.titleCopy}
                                    value={ad.titleCopy || ''}
                                    {...$field('titleCopy', (event) => this._handleChange(event))}
                                />
                            </FormRow>

                            <FormRow>
                                <Textbox
                                    id="txtBody"
                                    label="Body"
                                    name="bodyCopy"
                                    required
                                    type="textarea"
                                    validation={$validation.bodyCopy}
                                    value={ad.bodyCopy || ''}
                                    {...$field('bodyCopy', (event) => this._handleChange(event))}
                                />
                            </FormRow>

                            <FormRow>
                                <Textbox
                                    id="txtLink"
                                    label="Link URL"
                                    name="linkUrl"
                                    required
                                    type="text"
                                    validation={$validation.linkUrl}
                                    value={ad.linkUrl || ''}
                                    {...$field('linkUrl', (event) => this._handleChange(event))}
                                />
                            </FormRow>

                            <FormRow>
                                <Textbox
                                    id="txtPhoto"
                                    label="Photo URL"
                                    name="photoUrl"
                                    required
                                    type="text"
                                    validation={$validation.photoUrl}
                                    value={ad.photoUrl || ''}
                                    {...$field('photoUrl', (event) => this._handleChange(event))}
                                />
                            </FormRow>

                            <div />
                        </div>
                    {/*)}*/}

                    <FormRow>
                        <Textbox
                            id="txtThumbnail"
                            label="Thumbnail URL"
                            name="thumbnailUrl"
                            required
                            type="text"
                            validation={$validation.thumbnailUrl}
                            value={ad.thumbnailUrl || ''}
                            {...$field('thumbnailUrl', (event) => this._handleChange(event))}
                        />
                    </FormRow>

                    <FormRow columnCount={2} hasColumns>
                        <FormColumn>
                            <Textbox
                                id="txtThumbnailWidth"
                                label="Thumbnail Width"
                                name="thumbnailWidth"
                                required
                                type="number"
                                validation={$validation.thumbnailWidth}
                                value={ad.thumbnailWidth || ''}
                                {...$field('thumbnailWidth', (event) => this._handleChange(event))}
                            />
                        </FormColumn>

                        <FormColumn>
                            <Textbox
                                id="txtThumbnailHeight"
                                label="Thumbnail Height"
                                name="thumbnailHeight"
                                required
                                type="number"
                                validation={$validation.thumbnailHeight}
                                value={ad.thumbnailHeight || ''}
                                {...$field('thumbnailHeight', (event) => this._handleChange(event))}
                            />
                        </FormColumn>
                    </FormRow>

                    {/*<FormRow>
                        <Label>Placement</Label>

                        <div className="radio-wrapper">
                            <input
                                checked={ad.placement === 'main'}
                                id="rdoPlacementMain"
                                name="placement"
                                type="radio"
                                value="main"
                                {...$field('placement', (event) => this._handleChange(event))}
                            />
                            <Label htmlFor="rdoPlacementMain">Main</Label>
                        </div>

                        <div className="radio-wrapper">
                            <input
                                checked={ad.placement === 'news'}
                                id="rdoPlacementNews"
                                name="placement"
                                type="radio"
                                value="news"
                                {...$field('placement', (event) => this._handleChange(event))}
                            />
                            <Label htmlFor="rdoPlacementNews">News</Label>
                        </div>

                        {$validation.placement.show && <FormValidationMessage>{$validation.placement.error.reason}</FormValidationMessage>}
                    </FormRow>*/}

                    <FormRow>
                        <Label>Region</Label>

                        {REGIONS.map((r) => (
                            <div className="radio-wrapper" key={r}>
                                <input
                                    checked={ad.regions && ad.regions.includes(r)}
                                    id={`chkRegion${r}`}
                                    name="regions"
                                    type="checkbox"
                                    value={r}
                                    {...$field('regions', (event) => this._handleChange(event))}
                                />
                                <Label htmlFor={`chkRegion${r}`}>{r}</Label>
                            </div>
                        ))}
                    </FormRow>

                    <FormRow>
                        <Label>Status</Label>

                        <div className="radio-wrapper">
                            <input
                                checked={ad.status === 'active'}
                                id="rdoStatusActive"
                                name="status"
                                type="radio"
                                value="active"
                                {...$field('status', (event) => this._handleChange(event))}
                            />
                            <Label htmlFor="rdoStatusActive">Active</Label>
                        </div>

                        <div className="radio-wrapper">
                            <input
                                checked={ad.status === 'inactive'}
                                id="rdoStatusInactive"
                                name="status"
                                type="radio"
                                value="inactive"
                                {...$field('placement', (event) => this._handleChange(event))}
                            />
                            <Label htmlFor="rdoStatusInactive">Inactive</Label>
                        </div>

                        {$validation.status.show && <FormValidationMessage>{$validation.status.error.reason}</FormValidationMessage>}
                    </FormRow>

                    <FormRow className="button-wrapper" hasColumns>
                        <FormColumn>
                            <Button type="submit"
                                    disabled={isSaving}
                                    onClick={(event) => {
                                        event.preventDefault();
                                        $submit(() => this.handleSubmit(true), () => this.handleSubmit(false));
                                    }}>
                                Save
                                {isSaving === true ? <LoadingCircle outerColor="#ffffff" /> : null}
                            </Button>
                        </FormColumn>
                        <FormColumn>
                            <Button cancelStyles
                                    type="button"
                                    onClick={this._handleCancel}>
                                Cancel
                            </Button>
                        </FormColumn>
                    </FormRow>
                </Form>
            </Modal>
        )
    }
}

function adEditFormValidationConfig(props) {
    const { bodyCopy, name, photoUrl, status, thumbnailHeight, thumbnailWidth, thumbnailUrl, titleCopy, viewUrl } = props.ad;
    //const { useViewUrl } = props;

    return {
        fields: ['bodyCopy', 'linkUrl', 'name', 'photoUrl', 'placement', 'status', 'thumbnailHeight', 'thumbnailWidth', 'thumbnailUrl', 'titleCopy', 'viewUrl'],
        validations: {
            bodyCopy: [
                [isRequiredIfTrue, bodyCopy, status === 'active']
            ],
            name: [
                [isRequiredIfTrue, name, status === 'active']
            ],
            photoUrl: [
                [isRequiredIfTrue, photoUrl, status === 'active']
            ],
            status: [
                [isRequired, status]
            ],
            thumbnailHeight: [
                [isRequiredIfTrue, thumbnailHeight, status === 'active']
            ],
            thumbnailWidth: [
                [isRequiredIfTrue, thumbnailWidth, status === 'active']
            ],
            thumbnailUrl: [
                [isRequiredIfTrue, thumbnailUrl, status === 'active']
            ],
            titleCopy: [
                [isRequiredIfTrue, titleCopy, status === 'active']
            ],
            viewUrl: [
                [isRequiredIfTrue, viewUrl, status === 'active']
            ]
        }
    }
}

export default AdEditModal = validated(adEditFormValidationConfig)(AdEditModal);



// WEBPACK FOOTER //
// ./src/containers/AdsPage/AdEditModal/index.js